import { render, staticRenderFns } from "./AgentTransaction.vue?vue&type=template&id=74b8baa8&scoped=true"
import script from "./AgentTransaction.vue?vue&type=script&lang=js"
export * from "./AgentTransaction.vue?vue&type=script&lang=js"
import style0 from "./AgentTransaction.vue?vue&type=style&index=0&id=74b8baa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b8baa8",
  null
  
)

export default component.exports